<template>
  <div>
    <a-modal v-model:visible="dialogVisible"
             @ok="exportBtn"
             title="选择"
             @cancel="handleClose">
      <a-form :model="form"
              size="medium"
              ref="formRef"
              
              label-width="100rem">

        <a-form-item>
          <!-- <a-checkbox :indeterminate="indeterminate"
                      :checked="checkAll"
                      @change="handleCheckAllChange">
            全选
          </a-checkbox> -->
   <div class="text"> 您要生成的科目</div>
          <a-checkbox-group :options="cityOptions"
                            :value="checkedList"
                            style="margin-top: 14rem; "
                            @change="onChange" />

        </a-form-item>
           <div class="text">您要分析的时间段</div> 
            <div class="text2">系统默认近两个月来的分析及对比。您可以根据自己的做卷情况和想要对比的时间段选择要分析的时间段（本次时间）和需要对比的时间段（上次时间）。
<br>注意：选择的本次时间段内必须有套卷训练数据才可生成分析报告！</div>
            
          <a-form-item label="本次时间"  >
              <a-range-picker v-model:value="value1"
                              style="width:100%; "
                              value-format="YYYY-MM-DD HH:mm:ss"
                             show-time
                              separator="~"
                                :disabled-date="disabledDate"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </a-range-picker>
            </a-form-item>
     
            <a-form-item label="上次时间"  >
              <a-range-picker v-model:value="value2"
                              style="width:100%"
                                show-time
                                 :disabled-date="disabledDate2"
                              value-format="YYYY-MM-DD HH:mm:ss"
                              separator="~"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">

              </a-range-picker>
            </a-form-item>
        <a-form-item class="text1" v-if="has_explain == 1" >
          薄弱考点数量  
          <a-input-number id="inputNumber"
          style="margin-left: 253rem;"
                          v-model:value="point_num"
                          :min="1"
                          :max="10" />
        </a-form-item>
        <a-form-item  class="text1" v-if="has_explain == 1">
             各考点推送题目数量  
          <a-input-number id="inputNumber"
            style="margin-left: 193rem;"
                          v-model:value="question_num"
                          :min="1"
                          :max="20" />
        </a-form-item>
      </a-form>

    </a-modal>
  </div>
</template>

<script>
import { getExplainReport } from '@/api/home.js'
import { getUserSubject,getReport } from '@/api/subject.js'
import { saveAs } from "file-saver"
 import { Modal } from 'ant-design-vue';
 import { createVNode } from 'vue';
 import { ExclamationCircleOutlined } from '@ant-design/icons-vue';



export default {
  data () {
    return {
      dialogVisible: false,
      cityOptions: [],
      form: {
      },
      has_explain: 1,
      checkAll: false,
      checkedCities: [],
      checkedList: [],
      select_all: 0,
      indeterminate: false,
      question_num: 5,
      point_num: 5,
      invite_code: '',
   value1: [],
      value2: [],
    }
  },
 
  async created () {
       this.value1 = this.getRangeTime(30, 0)
    
    this.value2 = this.getRangeTime(60, 31)
        this.nickname = JSON.parse(window.localStorage.getItem('userInfo'))?JSON.parse(window.localStorage.getItem('userInfo')).nickname:''

    const { data } = await getUserSubject()
    this.cityOptions = data.list.map(item =>
      item.subject_name,

    );
    this.cityOptionsCopy = data.list.map(item => {
      return {
        subject_id: item.subject_id,
        subject_name: item.subject_name,
      }
    });
    this.getSystemName();
  },
 
  methods: {
disabledDate(current, info) {
  if (!this.value2 || !this.value2[1]) return false   // 必须已选 v2 结束日期
  const lowerDay = this.value2[1].slice(0, 10)        // v2 结束当天（下限）
  const curDay   = current.format('YYYY-MM-DD')
 
  return curDay <= lowerDay
},
 disabledDate2(current,info) {
  if (!this.value1 || !this.value1[0]) return false
  const upperDay = this.value1[0].slice(0, 10)
   const lowDay = this.value1[1].slice(0, 10)
  const curDay   = current.format('YYYY-MM-DD')
     return curDay >= upperDay  
},
 
    getSystemName () {
      const fullUrl = window.location.href;
      const domain = fullUrl.split("#")[0]; //去掉#及其后面的部分
      this.$http({
        url: '/api/v1/getSchollBrand',
        method: 'get',
        params: {
          brand_url: domain
        }
      }).then(res => {
        if (res.data.list.is_brand == '1') {
          this.invite_code = res.data.list.invite_code;
        }
      })
      console.log(this.invite_code)
    },
    getRangeTime (start, end) {
      let arr = []
      let startTime = new Date()
      let endTime = new Date()
      let n = startTime.getTimezoneOffset() //时差
      arr[0] = new Date(startTime - 3600 * 1000 * 24 * start - n * 60 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      arr[1] = new Date(endTime - 3600 * 1000 * 24 * end - n * 60 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')

      return arr
    },
    onChange (checkedList, cityOptions) {
console.log('checkedList',checkedList)
if(checkedList.length >1)
{return}
      this.indeterminate = !!checkedList.length && checkedList.length < this.cityOptions.length;
      this.checkAll = checkedList.length === this.cityOptions.length;
      this.checkedList = JSON.parse(JSON.stringify(checkedList))
    },
    handleCheckAllChange (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.cityOptions : [],
        indeterminate: false,
        checkAll: e.target.checked,
      });
      if (e.target.checked) {

        this.select_all = 1
      }
      else {

        this.select_all = 0
      }
    },

    handleClose () {
      this.dialogVisible = false
      this.checkedList = []
    },
    exportBtn () {
      console.log('this.checkedList', this.checkedList)
      let exportArr = []
      this.cityOptionsCopy.forEach(element => {
        this.checkedList.forEach(item => {
          if (element.subject_name == item) {
            exportArr.push(element)
          }
        })
      });
      console.log('exportArr', exportArr)
      exportArr.forEach(item => {
        this.postExport(item.subject_id, item.subject_name)
      })
      this.handleClose()

    },
    base64ToBlob (base64) {
      const byteCharacters = atob(base64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: 'application/octet-stream' });
    },

    async postExport (subject_id, subject_name) {

      this.$parent.btnDisabled = true


      await getReport({ show_question: this.has_explain, subject_id,  first_begin_time: this.value1[0],
        first_end_time: this.value1[1],
        second_begin_time: this.value2[0],
        second_end_time: this.value2[1],  question_num: this.question_num, point_num: this.point_num, invite_code: this.invite_code }).then(res => {
          if(res.data.code == 40022003){
          const self = this; // 缓存 this
              Modal.confirm({
    title: '温馨提示',
    icon: createVNode(ExclamationCircleOutlined),
    okText: '知道了',
    // cancelText: '取消',
     
  cancelButtonProps: { style: { display: 'none' } },
  content: createVNode(
    'div',
    {},
    [
      '您所选时间段内未有对应训练数据记录，建议您尝试以下操作:',
      createVNode('br'),
      '1. 修改时间段',
      createVNode('br'),
      '2. 去训练后再来生成~'
    ]
  ),   onOk: () => {
    self.handleClose()
    },
    onCancel () {
      return
      //console.log('Cancel');
    },
    class: 'test',
  });
  return
          }else if(res.data.code ==  40022002 || res.data.code ==  40022001){
          const self = this; // 缓存 this
              Modal.confirm({
    title: '温馨提示',
    icon: createVNode(ExclamationCircleOutlined),
    okText: '知道了',
    // cancelText: '取消',
     
  cancelButtonProps: { style: { display: 'none' } },
  content: createVNode(
    'div',
    {},
    [
      '根据您所选时间段内的训练记录，没有发现薄弱点，建议您尝试以下操作:',
      createVNode('br'),
      '1. 修改时间段',
      createVNode('br'),
      '2. 去增加训练数量~'
    ]
  ),   onOk: () => {
    self.handleClose()
    },
    onCancel () {
      return
      //console.log('Cancel');
    },
    class: 'test',
  });
  return
          }else if(res.data.code == 0){
            const self = this; // 缓存 this
              Modal.confirm({
    title: '温馨提示',
    icon: createVNode(ExclamationCircleOutlined),
    okText: '继续生成',
    cancelText: '取消',
     
  cancelButtonProps: { style: { display: 'none' } },
  content: createVNode(
    'div',
    {},
    [
      '根据您所选时间段内的训练记录，没有发现薄弱点，建议您尝试以下操作:',
      createVNode('br'),
      '1. 修改时间段',
      createVNode('br'),
      '2. 去增加训练数量~'
    ]
  ),   onOk: () => {
    self.exportBtn()
    },
    onCancel () {
      
      self.dialogVisible = false
    },
    class: 'test',
  });
  return
          }
        const a = document.createElement("a")
        const blob = this.base64ToBlob(res.data.data)
        console.log('blob', blob)
        a.href = window.URL.createObjectURL(blob)


        if (this.checkAll) {
          if (this.has_explain == 1) {

             a.download = `${this.nickname}${subject_name}定制学案.pdf`
            a.click()
          } else {
            a.download = `${this.nickname}${subject_name}学情分析.pdf`
            a.click()

          }
        } else {
          if (this.has_explain == 1) {
              a.download = `${this.nickname}${subject_name}定制学案.pdf`
            a.click()
          } else {
            a.download = `${this.nickname}${subject_name}学情分析.pdf`
            a.click()
          }
        }
        this.$parent.btnDisabled = false


      })

      // const data = await getExplainReport({ has_explain: this.has_explain, subject_id, select_all: this.select_all })
      // if (data.size > 0) {
      //   this.$parent.btnDisabled = false
      // }
      // let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      // if (this.checkAll) {
      //   if (this.has_explain == 1) {
      //     saveAs(blob, `${subject_name}定制学案.docx`)
      //   } else {
      //     saveAs(blob, `${subject_name}题集.docx`)
      //   }
      // } else {
      //   if (this.has_explain == 1) {
      //     saveAs(blob, `${subject_name}定制学案.docx`)
      //   } else {
      //     saveAs(blob, `${subject_name}题集.docx`)
      //   }
      // }

    }
  }
}
</script>

<style lang="scss" scoped>
.text_warp {
  word-break: break-all;
  font-weight: 500;
  color: #666666 !important;
  line-height: 23rem;
  font-size: 16rem;
  // padding: 27rem;
  padding-top: 0;
}
 .text2{
  color: var(--light-999999, #999);
font-size: 16rem;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
margin-bottom:14rem;
margin-top:6rem
 }
 .text1{
   font-size: 20rem;
  color: var(--light-333333, #333);
 
font-style: normal;
font-weight: 600;
 }
.text {
  display: flex;
  flex-direction: column;
  font-size: 20rem;
  color: var(--light-333333, #333);
  
font-style: normal;
font-weight: 600;
 
}
.btn_warp {
  width: 720rem;
  height: 62rem;
  border-top: 1rem solid #eeeeee;
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0rem 0rem 0rem 0rem;
  opacity: 1;
  align-items: center;
  justify-content: center;

  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    // font-size: 24rem;
    &:nth-child(1) {
      width: 40rem;
      height: 60rem;
      font-size: 20rem;

      font-weight: 400;
      border-right: 1rem solid #eeeeee;
      color: #333333;

      line-height: 30rem;
      -webkit-background-clip: text;
    }
    &:nth-child(2) {
      width: 40rem;
      height: 30rem;

      font-size: 20rem;

      font-weight: 400;
      color: #2196f3;
      line-height: 30rem;
      -webkit-background-clip: text;
    }
  }
}
::v-deep .ant-form-item-label > label{
  font-size:20rem
}
::v-deep .ant-checkbox-inner{
  width: var(--Iconsize-L, 24rem);
height: 24rem;
aspect-ratio: 1/1;
border-radius: 14rem;
}
::v-deep .ant-checkbox-group-item + .ant-checkbox-group-item {
  font-size: 20rem !important;
}

::v-deep .ant-checkbox-group-item {
font-size: 20rem !important;
}
::v-deep .el-dialog {
  border-radius: 10rem;
  width: 720rem;
  height: auto;
  background: #ffffff;
  border-radius: 24rem 24rem 24rem 24rem;
  opacity: 1;
}

::v-deep .el-textarea__inner {
  font-size: 16rem;
}
::v-deep .el-form-item__content {
  margin-left: 37rem !important;
}

::v-deep .el-input__inner {
  // height: 45rem;
  line-height: 45rem;
  font-size: 16rem;
}
::v-deep .el-checkbox__input {
  padding-top: 4rem;
}
::v-deep .el-form-item__label {
  line-height: 45rem;
  font-size: 18rem;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  display: none;
}
::v-deep .el-dialog__title {
  width: 144rem;
  height: 36rem;
  font-size: 24rem;

  font-weight: 600;
  color: #333333;
  line-height: 36rem;
  -webkit-background-clip: text;
}

::v-deep .el-checkbox-group {
  text-align: left; //这个很关键，否则最后一行是居中状态
}
::v-deep .el-checkbox__inner {
  width: 23rem;
  height: 23rem;
}
::v-deep .el-checkbox__label {
  font-size: 20rem;
  padding-left: 8rem;
}
::v-deep .el-checkbox {
  // margin-left: 20rem !important;
  margin-right: 24rem;
  // width: 72rem; //根据内容设置宽度
  height: 30rem;
  // padding-left: 0rem;
  font-size: 20rem;
  margin-bottom: 24rem;
  text-align: left; //这个很关键，否则每一行都是居中状态
}
</style>